import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ContentWrapper, Markdown } from '../../components/containers';
import { BackgroundPageTitle, VideoPlayer } from '../../components/molecules';
import { NewsSidebar } from '../../components/organisms';
import { NewsController } from '../../lib/controllers';
import { INews } from '../../types';
import { IProps } from './types';
import { withLayout } from '../../hocs/withLayout';
import { withAuth } from '../../hocs';

export const NewsSingle: React.FC<IProps> = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [news, setNews] = useState<INews>({} as any);
    const newsCtrl = new NewsController();

    const getNews = async (slug: string): Promise<any> => {
        const data = await newsCtrl.getSingleNews(slug);
        setNews(data);
    }

    useEffect(() => {
        getNews(params.slug as string).then();
    }, [params])

    const goBackAction = () => {
        navigate(-1);
    }

    return (
        <>
            {
                !!news && !!news.imageURL &&
                <BackgroundPageTitle imageURL={news.imageURL} title={news.title} subtitle={news.subtitle} heigthSize="sm" />
            }

            <ContentWrapper className="flex flex-col md:flex-row gap-3 mt-6 pb-6">
                <div className="flex-grow bg-white dark:bg-gray-800 px-6 py-4 shadow-sm rounded-md border-1 dark:border-gray-700">
                    <div className="flew-wrap">
                        {
                            news.externalVideoURL &&
                            <div className="pb-4">
                                <VideoPlayer videoURL={news.externalVideoURL} />
                            </div>
                        }
                        {
                            news.showImageInContent &&
                            <div className="w-full pb-4">
                                <img src={news.imageURL} className="bg-cover" alt="" />
                            </div>
                        }
                        <Markdown content={news.content} />

                    </div>
                </div>

                <div className="relative">
                    <NewsSidebar goBackAction={goBackAction} {...news} />
                </div>
            </ContentWrapper>
        </>
    )
}

export const NewsSinglePage = withLayout(withAuth(NewsSingle))